import React from 'react';

import NewsletterSignUp from '../NewsletterSignup';
import styles from './footerStyles';

const Footer = ({ currentUser, gdprColorScheme, gdpr, isSubscribed, newsletter, newsletterId }) => {
  return (
    <div className={styles.feedNewsletterContainer} id="feed-newsletter-container-footer">
      <div className={styles.feedNewsletterWrapper}>
        <div className={styles.newsletterImageCard}>
          <img src={newsletter.cardImageUrlImgix} />
        </div>
        <div className={styles.newsletterFormWrapper}>
          <div className={styles.frequency}>{newsletter.frequency}</div>
          <div className={styles.byline}>
            {newsletter.name} by {newsletter.author.name}
          </div>
          <div className={styles.description}>{newsletter.description}</div>
          <NewsletterSignUp
            newsletterId={newsletterId}
            isSubscribed={isSubscribed}
            currentUser={currentUser}
            newsletterName={newsletter.name}
            gdpr={gdpr}
            gdprColorScheme={gdprColorScheme}
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
